<freemium *ngIf="isFreemium()"></freemium>

<integration-options
  *ngIf="!isFreemium()"
  [location_id]="getLocationId()"></integration-options>
